<template>
    <v-container fluid>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Claims Post Submission ({{ totalMatches }})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
                <v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>
                <v-btn
                    @click="showImportGrv = !showImportGrv"
                    color="secondary darken-1"
                    icon
                    v-if="hasAdminRole"
                >
                    <v-icon>mdi-file</v-icon>
                </v-btn>
                <v-btn
                    @click="showImportStatus = !showImportStatus"
                    color="secondary darken-3"
                    icon
                    v-if="hasAdminRole"
                >
                    <v-icon>mdi-file</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="claimsView === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="claimView.id"
                    cols="12"
                    v-for="claimView in claimsView"
                >
                    <v-card
                        class="incident-card fill-height"
                        elevation="4"
                        style="overflow: hidden"
                    >
                        <v-card
                            flat
                            @click="loadClaimForm(claimView.id)"
                        >
                        <v-card-title
                            
                        >#{{ claimView.id }}</v-card-title>
                        <v-card-subtitle>
                            Provider:
                            {{
                            getProviderName(claimView.providerId)
                            }}
                            <br />
                            Incident: #{{ claimView.incidentId }}
                            <br />
                            Funding Type:
                            {{
                            getFundingTypeName(
                            claimView.fundingType
                            )
                            }}
                            <br />
                            {{ claimView.patientName }} {{claimView.patientSurname}}
                            <!--<span
                                :key="pi"
                                v-for="(
                                    patientName, pi
                                ) in getPatientsFromAccounts(
                                    claimView.accounts
                                )"
                            >
                                {{ patientName }}
                                
                            </span>-->
                            <br />
                            Number of Accounts:
                            {{ claimView.accounts.length }}
                            <br />
                            Face Value: R{{
                            claimView.totalFaceValue.toFixed(2)
                            }}
                            <br />
                            Purchase Value: R{{
                            claimView.totalPurchaseValue.toFixed(2)
                            }}
                            <br />
                            <br />In Day Batch:
                            <v-icon
                                color="success"
                                v-if="claimView.dayBatchId > 0"
                            >mdi-check</v-icon>
                            <v-icon
                                color="error"
                                v-else
                            >mdi-close</v-icon>
                        </v-card-subtitle>
                        </v-card>
                        <v-card-subtitle class="py-0 my-0">
                            <strong>Accounts</strong>
                        </v-card-subtitle>
                        <v-card
                            :key="indexA"
                            @click.stop="
                                $router.push({
                                    name: 'Accounts',
                                    params: { accountId: account.id },
                                })
                            "
                            class="patient-panel"
                            rounded="0"
                            v-for="(account, indexA) in claimView
                                .accounts"
                        >
                            <v-card-text class="my-0 py-0">
                                <v-row justify="start">
                                    <v-col cols="12">
                                        <div style="display: inline-block">#{{ account.id }}</div>
                                        <span
                                        v-show="account.hasPrefundFunding"
                                        >
                                            <v-chip
                                                class="ma-1"
                                                color="secondary lighten-1"
                                                dark
                                                small
                                            >
                                                Prefund GRV Number:
                                                {{ account.grvNumberPrefund }}
                                            </v-chip>
                                            <v-chip
                                                class="ma-1"
                                                color="secondary lighten-1"
                                                dark
                                                small
                                            >
                                                Prefund Face Value:
                                                {{
                                                account.faceValuePrefund.toFixed(2)
                                                }}
                                            </v-chip>
                                            <v-chip
                                                class="ma-1"
                                                color="secondary lighten-1"
                                                dark
                                                small
                                            >
                                                Prefund Purchase Value:
                                                {{
                                                account.purchaseValuePrefund.toFixed(2)
                                                }}
                                            </v-chip>
                                        </span>
                                        <span
                                        v-show="account.hasAdminFunding"
                                        >
                                            <v-chip
                                                class="ma-1"
                                                color="secondary darken-1"
                                                dark
                                                small
                                            >
                                                Administered GRV Number:
                                                {{ account.grvNumberAdmin }}
                                            </v-chip>
                                            <v-chip
                                                class="ma-1"
                                                color="secondary darken-1"
                                                dark
                                                small
                                            >
                                                Administered Face Value:
                                                {{
                                                account.faceValueAdmin.toFixed(2)
                                                }}
                                            </v-chip>
                                            <v-chip
                                                class="ma-1"
                                                color="secondary darken-1"
                                                dark
                                                small
                                            >
                                                Administered Purchase Value:
                                                {{
                                                account.purchaseValueAdmin.toFixed(2)
                                                }}
                                            </v-chip>
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <!--EDIT FORM SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="claimFormVisible"
        >
            <v-sheet
                class="base-background"
                min-height="100%"
            >
                <v-toolbar
                    color="secondary darken-1"
                    dark
                >
                    <v-btn
                        @click="closeClaimForm"
                        dark
                        icon
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Claim Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container>
                    <v-row
                        align="center"
                        justify="center"
                        v-if="true"
                    >
                        <ClaimPostSubmissionForm
                            :claim-id="claimFormClaimId"
                            :claim-in="null"
                            :identity-types="identityTypes"
                            :key="claimFormClaimId"
                            :providers="providers"
                            :show-notes="true"
                            @saved="updateClaim"
                            @notify="notify"
                        />
                    </v-row>
                </v-container>
                            <v-snackbar
                                :color="notifyColor"
                                :timeout="15000"
                                top
                                v-model="notifyShow"
                            >
                                {{ notifyMessage }}
                                <template v-slot:action="{ attrs }">
                                    <v-btn
                                        @click="notifyShow = false"
                                        class="text-none"
                                        icon
                                        v-bind="attrs"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                            </v-snackbar>
            </v-sheet>
        </v-dialog>

        <!--#region--grv import form-->

        <v-dialog
            transition="scroll-x-reverse-transition"
            v-model="showImportGrv"
            width="350px"
        >
            <ClaimGrvImportForm @close="showImportGrv = false" />
        </v-dialog>

        <v-dialog
            transition="scroll-x-reverse-transition"
            v-model="showImportStatus"
            width="350px"
        >
            <ClaimStatusImportForm @close="showImportStatus = false" />
        </v-dialog>

        <!--#endregion-->
        <!--FILTER SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            transition="scroll-x-reverse-transition"
            v-model="showFilters"
            width="350px"
        >
            <v-card>
                <v-card-title>Claim Filtering</v-card-title>
                <v-card-text>
                    <v-select
                        :items="providers"
                        @change="
                            () => {
                                pageNo = 1;
                                paginationDebounce(filterDebounceTime);
                            }
                        "
                        class="my-0"
                        clearable
                        item-text="value"
                        item-value="key"
                        label="Provider"
                        v-model="filterProviderId"
                    ></v-select>
                    <v-divider class="mt-3 mb-8"></v-divider>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="resetFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Reset</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="showFilters = !showFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--PAGINATION SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
import ClaimPostSubmissionForm from "../components/forms/ClaimPostSubmissionForm.vue";
import ClaimGrvImportForm from "../components/forms/ClaimGrvImportForm.vue";
import ClaimStatusImportForm from "../components/forms/ClaimStatusImportForm.vue";
import RoleType from "../constants/RoleType.constant";
import dateToString from "../helpers/dateToString";
import uuid4 from "../helpers/uuid4";

export default {
    name: "Claims",
    props: [
        "acceptedNotSubmitted",
        "unresolvedRejection",
        "unresolvedObjection",
        "submittedMissingLink",
        "submittedWithLink",
        "shortPaid",
        "fullPaid",
        "providerId",
        "areaId",
        "agedDaysMin",
        "agedDaysMax",
        "isFinal",
        "claimStatus",
        "agedDaysMinObjection",
        "agedDaysMaxObjection",
        "agedDaysMinRejection",
        "agedDaysMaxRejection",
        "agedDaysMinSubmission",
        "agedDaysMaxSubmission",
        "agedDaysMinQueried",
        "agedDaysMaxQueried",
        "agedDaysMinStatusRD",
        "agedDaysMaxStatusRD",
        "agedDaysMinStatusVV",
        "agedDaysMaxStatusVV",
        "agedDaysMinStatusO",
        "agedDaysMaxStatusO",
        "unresolvedQuery",
        "resubmittedMissingLink",
        "agedDaysPaymentStatusMin",
        "agedDaysPaymentStatusMax",
        "paymentStatus",
        "agedDaysMinStatusF",
        "agedDaysMaxStatusF",
        "assignedUserId",
    ],
    data: function() {
        return {
            //main data
            claimsView: null,
            fundingTypes: [],
            identityTypes: [],
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            searchString: "",
            orderBy: "",
            sortOrder: 0,
            paginationTimeout: null,
            requestId: uuid4(),
            totalMatches: null,
            userRoles: [],

            //new claims list
            claimsNonValidatedVisible: false,
            claimsNonValidatedKey: null,

            //form data
            claimFormVisible: false,
            claimFormClaimId: 0,

            providers: [],

            //filters
            showFilters: false,
            filterDebounceTime: 500,
            filterProviderId: this.providerId > 0 ? this.providerId : null,
            filterAreaId: this.areaId > 0 ? this.areaId : null,
            //

            showImportGrv: false,
            showImportStatus: false,

            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
        };
    },
    created: async function() {
        this.userRoles = await this.$store.dispatch(
            "authentication/getUserRoles"
        );
    },
    mounted: async function() {
        this.providers = await this.$store.dispatch("providers/getlist");
        this.fundingTypes = await this.$store.dispatch(
            "accounts/getFundingTypes"
        );
        this.identityTypes = await this.$store.dispatch("identities/getTypes");
        await this.getClaims();
        this.providers = await this.$store.dispatch("providers/getlist");
    },
    components: {
        ClaimPostSubmissionForm,
        ClaimGrvImportForm,
        ClaimStatusImportForm
        //
    },
    computed: {
        hasAdminRole: function() {
            return this.userRoles.some(x => x == RoleType.Admin);
        }
    },
    methods: {
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        async getClaims() {
            var requestId = (this.requestId = uuid4());

            var claimsResponse = await this.$store.dispatch(
                "claims/getreducedview",
                {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder,
                        noDaybatchNoPrinted: false,

                        providerId: this.filterProviderId
                            ? this.filterProviderId
                            : null,
                        areaId: this.filterAreaId ? this.filterAreaId : null,
                        //NEW ONES TO BE ADDED TO FILTER GUI AND FILTER RESET
                        agedDaysMin: this.agedDaysMin ? this.agedDaysMin : null,
                        agedDaysMax: this.agedDaysMax ? this.agedDaysMax : null,

                        acceptedNotSubmitted: this.acceptedNotSubmitted
                            ? this.acceptedNotSubmitted
                            : false,
                        unresolvedRejection: this.unresolvedRejection
                            ? this.unresolvedRejection
                            : false,
                        unresolvedObjection: this.unresolvedObjection
                            ? this.unresolvedObjection
                            : false,
                        submittedMissingLink: this.submittedMissingLink
                            ? this.submittedMissingLink
                            : false,
                        submittedWithLink: this.submittedWithLink
                            ? this.submittedWithLink
                            : false,
                        shortPaid: this.shortPaid ? this.shortPaid : false,
                        fullPaid: this.fullPaid ? this.fullPaid : false,
                        isFinal: this.isFinal ? this.isFinal : false,
                        claimStatus: this.claimStatus ? this.claimStatus : null,
                        agedDaysMinObjection: this.agedDaysMinObjection ? this.agedDaysMinObjection : null,
                        agedDaysMaxObjection: this.agedDaysMaxObjection ? this.agedDaysMaxObjection : null,
                        agedDaysMinRejection: this.agedDaysMinRejection ? this.agedDaysMinRejection : null,
                        agedDaysMaxRejection: this.agedDaysMaxRejection ? this.agedDaysMaxRejection : null,
                        agedDaysMinSubmission: this.agedDaysMinSubmission ? this.agedDaysMinSubmission : null,
                        agedDaysMaxSubmission: this.agedDaysMaxSubmission ? this.agedDaysMaxSubmission : null,
                        agedDaysMinQueried: this.agedDaysMinQueried ? this.agedDaysMinQueried : null,
                        agedDaysMaxQueried: this.agedDaysMaxQueried ? this.agedDaysMaxQueried : null,
                        agedDaysMinStatusRD: this.agedDaysMinStatusRD ? this.agedDaysMinStatusRD : null,
                        agedDaysMaxStatusRD: this.agedDaysMaxStatusRD ? this.agedDaysMaxStatusRD : null,
                        agedDaysMinStatusVV: this.agedDaysMinStatusVV ? this.agedDaysMinStatusVV : null,
                        agedDaysMaxStatusVV: this.agedDaysMaxStatusVV ? this.agedDaysMaxStatusVV : null,
                        agedDaysMinStatusO: this.agedDaysMinStatusO ? this.agedDaysMinStatusO : null,
                        agedDaysMaxStatusO: this.agedDaysMaxStatusO ? this.agedDaysMaxStatusO : null,
                        unresolvedQuery: this.unresolvedQuery ? this.unresolvedQuery : false,
                        resubmittedMissingLink: this.resubmittedMissingLink ? this.resubmittedMissingLink : false,

                        agedDaysPaymentStatusMin: this.agedDaysPaymentStatusMin ? this.agedDaysPaymentStatusMin : null,
                        agedDaysPaymentStatusMax: this.agedDaysPaymentStatusMax ? this.agedDaysPaymentStatusMax : null,
                        paymentStatus: this.paymentStatus ? this.paymentStatus : null,
                        agedDaysMinStatusF: this.agedDaysMinStatusF ? this.agedDaysMinStatusF : null,
                        agedDaysMaxStatusF: this.agedDaysMaxStatusF ? this.agedDaysMaxStatusF : null,
                        assignedUserId: this.assignedUserId ? this.assignedUserId : null,
                    },
                    requestId: requestId
                }
            );

            if (this.requestId == claimsResponse.requestId) {
                //claimsResponse.data.page.forEach(x =>this.claimApplyDisciplineName(x));
                this.claimsView = claimsResponse.data.page;
                this.totalMatches = claimsResponse.data.total;
                this.pagesCount = Math.ceil(
                    claimsResponse.data.total / this.pageSize
                );
            }
        },
        paginationDebounce(debounceTime) {
            if (this.claimsView !== null) this.claimsView = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(this.getClaims, debounceTime);
        },
        setSearch(value) {
            this.searchString = value;
            this.pageNo = 1;
            this.pagesCount = 0;
            this.paginationDebounce(1000);
        },
        resetFilters() {
            this.filterProviderId = null;
            this.filterPatient = null;
            this.paginationDebounce(0);
        },
        /*
        claimApplyDisciplineName(claim) {
            claim.disciplineName = this.claimDisciplines.find(
                y => y.id == claim.disciplineId
            ).name;
        },*/
        newClaim() {
            this.loadClaimForm(0);
        },
        loadClaimForm(claimId) {
            this.claimFormClaimId = claimId;
            this.claimFormVisible = true;
        },
        closeClaimForm() {
            this.claimFormVisible = false;
            this.claimFormClaimId = null;
        },
        updateClaim() {
            this.paginationDebounce(0);
        },
        getProviderName(id) {
            var i = this.providers
                ? this.providers.find(x => x.key == id)
                : null;
            return i ? i.value : "";
        },
        getFundingTypeName(id) {
            var i = this.fundingTypes
                ? this.fundingTypes.find(x => x.key == id)
                : null;
            return i ? i.value : "";
        },

        getIdentityTypeName(id) {
            var i = this.identityTypes
                ? this.identityTypes.find(x => x.key == id)
                : null;
            return i ? i.value : "";
        },

        getPatientsFromAccounts(accounts) {
            return accounts.reduce(function(r, e) {
                if (!(e.patientId in r))
                    r[e.patientId] = e.patientName + " " + e.patientSurname;
                return r;
            }, {});
        },
        dateToString(date) {
            return dateToString(date ? new Date(date) : null);
        },
        loadClaimsNonValidated() {
            this.claimsNonValidatedVisible = true;
            this.claimsNonValidatedKey = 0;
        },
        closeClaimsNonValidated() {
            this.claimsNonValidatedVisible = false;
            this.claimsNonValidatedKey = null;
        }
    }
};
</script>

<style lang="stylus" scoped>
.incident-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.theme--dark {
    .patient-panel {
        .v-card {
            background-color: rgba(127, 127, 127, 0.1);
        }
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
